import React from 'react'
import { View, Text, Font } from '@react-pdf/renderer'
import { PropTypes } from 'prop-types'
import { themeConfig } from '../../config/theme.config'

const BoxLeft = ({
  value,
  index,
  width,
  title,
  color,
  objectiveMet,
  textAlign = 'center'
}) => {
  const boxLeft = {
    textAlign,
    width,
    borderRight: '1 solid grey',
    borderBottom: '1 solid grey',
    borderLeft: '1 solid grey',
    padding: '5pt',
    display: 'flex',
    fontSize: 11,
    justifyContent: 'center',
    backgroundColor: objectiveMet ? themeConfig.semcogBlue1 : 'transparent',
    color: objectiveMet ? 'white' : color || 'black',
    fontFamily: 'Roboto'
  }

  const borderTop = { borderTop: '1 solid grey' }
  return (
    <View
      style={index === 0 ? [boxLeft, borderTop, title] : [boxLeft, title]}
      wrap={false}
    >
      <Text>{value}</Text>
    </View>
  )
}

export default BoxLeft

BoxLeft.propTypes = {
  title: PropTypes.string,
  width: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.Image,
    PropTypes.bool
  ]),
  index: PropTypes.number,
  color: PropTypes.string,
  objectiveMet: PropTypes.bool,
  textAlign: PropTypes.string
}
